import { render, staticRenderFns } from "./timeOut.vue?vue&type=template&id=30f1a0fa&scoped=true&"
var script = {}
import style0 from "./timeOut.vue?vue&type=style&index=0&id=30f1a0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1a0fa",
  null
  
)

export default component.exports